module.exports = __webpack_public_path__ + "img/banner-bisa-belanja-popup.ff3246eb.webp";